import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../Contexts/main.context';
import { API_BASE_URL } from '../../api';
import './clientCitationBoard.style.scss';

const citationDateKey = (citation) => {
     const year = Number(citation.citationYear);
     const month = Number(citation.citationMonth);
     const day = Number(citation.citationDay || 0);
     if (!Number.isInteger(year) || year < 1 || year > 9999 ||
          !Number.isInteger(month) || month < 1 || month > 12 ||
          !Number.isInteger(day) || day < 0 || day > 31) return null;
     const date = new Date(0);
     date.setUTCFullYear(year, month - 1, day || 1);
     if (date.getUTCMonth() !== month - 1) return null;
     return year * 10000 + month * 100 + day;
};

const urlStatusLabels = { ok: 'Working', not_found: '404 Not Found', missing: 'No URL', error: 'Could not verify' };
const formatCheckedAt = (value) => {
     if (!value) return null;
     const date = new Date(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value) ? value.replace(' ', 'T') + 'Z' : value);
     return Number.isFinite(date.getTime()) ? date.toLocaleString(undefined, {
          year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
     }) : null;
};

const ClientCitationBoard = () => {
     const { activeClient, originalID } = useContext(AccountContext);
     const [citations, setCitations] = useState([]);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState('');
     const datedCitations = citations.map(citationDateKey).filter(date => date !== null);
     const latestDate = datedCitations.length ? Math.max(...datedCitations) : null;

     useEffect(() => {
          const controller = new AbortController();
          setLoading(true);
          setError('');
          fetch(API_BASE_URL + 'clientSide.php', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('LGOUser')}` },
               body: JSON.stringify({ script: 'getCitations', locationID: originalID, token: localStorage.getItem('LGOUser') }),
               signal: controller.signal,
          }).then(async response => {
               const data = await response.json();
               if (!response.ok || data.status !== 'success') throw new Error(data.message || 'Unable to load citations.');
               setCitations(data.data || []);
          }).catch(error => {
               if (!controller.signal.aborted) setError(error.message);
          }).finally(() => {
               if (!controller.signal.aborted) setLoading(false);
          });
          return () => controller.abort();
     }, [originalID]);

     const safeLink = (value) => {
          const text = String(value || '').trim();
          if (!text) return null;
          try {
               const url = new URL(text.startsWith('//') ? `https:${text}` : /^[a-z][a-z0-9+.-]*:/i.test(text) ? text : `https://${text}`);
               return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
          } catch { return null; }
     };

     return (
          <div className="w-100 client-citation-board">
               <h3>{activeClient?.companyName} — {activeClient?.theLocation}</h3>
               {loading ? <p role="status">Loading citations…</p> : error ? <p className="alert alert-danger" role="alert">{error}</p> : <>
                    <p>{citations.length} citations</p>
                    {citations.length === 0 ? <p>No active citations for this location.</p> : <div className="table-responsive"><table className="table table-striped">
                         <thead><tr><th>Directory</th><th>Citation</th></tr></thead>
                         <tbody>{citations.map(citation => {
                              const link = safeLink(citation.CitationLink);
                              const checkedAt = formatCheckedAt(citation.URLCheckedAt);
                              return <tr key={citation.ID} className={latestDate !== null && citationDateKey(citation) === latestDate ? 'table-success' : undefined}><td>{citation.Domain}{urlStatusLabels[citation.URLStatus] && <small className="d-block">URL Status: {urlStatusLabels[citation.URLStatus]}</small>}{checkedAt && <small className="d-block">Last checked: {checkedAt}</small>}</td><td>{link ? <a className="client-citation-link" href={link} target="_blank" rel="noopener noreferrer"><span className="d-none d-md-inline">{citation.CitationLink}</span><span className="d-md-none">View citation</span></a> : 'No link available'}</td></tr>;
                         })}</tbody>
                    </table></div>}
               </>}
          </div>
     );
};
export default ClientCitationBoard;
